import { useTranslation } from '@/i18n';
import {
  ActionMenu,
  IconCollapsed,
} from '@moneyforward/ap-frontend-components';
import { ExportCustomTransactionItemOptionsBodyCsvEncoding } from 'ap-openapi';
import { FC, memo, useMemo } from 'react';
import { MenuItem } from './MenuItem';

export type Props = {
  isDisabled?: boolean;
  onExport: (
    encoding: ExportCustomTransactionItemOptionsBodyCsvEncoding
  ) => void;
};

enum ENCODINGS {
  shift_jis = 'shift_jis',
  utf_8 = 'utf-8',
}

export const ExportButton: FC<Props> = memo(({ isDisabled, onExport }) => {
  const { t } = useTranslation();

  return (
    <ActionMenu
      buttonProps={useMemo(
        () => ({
          name: t('transaction_items.detail.export_csv.button_label'),
          children: t('transaction_items.detail.export_csv.button_label'),
          isDisabled: isDisabled,
          color: 'primary',
          rightIcon: <IconCollapsed height={0} width={0} />,
        }),
        [isDisabled, t]
      )}
      type='button'
      disabled={isDisabled}
      items={useMemo(
        () => [
          {
            key: 'UFT8',
            label: (
              <MenuItem
                label={t('transaction_items.detail.export_csv.options.utf_8')}
                tooltip={t(
                  'transaction_items.detail.export_csv.options.utf_8.tooltip'
                )}
              />
            ),
            onClick: () => {
              onExport(ENCODINGS.utf_8);
            },
          },
          {
            key: 'shifJis',
            label: (
              <MenuItem
                label={t(
                  'transaction_items.detail.export_csv.options.shift_jis'
                )}
                tooltip={t(
                  'transaction_items.detail.export_csv.options.shift_jis.tooltip'
                )}
              />
            ),
            onClick: () => {
              onExport(ENCODINGS.shift_jis);
            },
          },
        ],
        [onExport, t]
      )}
    />
  );
});

ExportButton.displayName = 'ExportButton';
